import { render, staticRenderFns } from "./_confirmOrder.vue?vue&type=template&id=e4ee3eb2"
import script from "./_confirmOrder.vue?vue&type=script&lang=js"
export * from "./_confirmOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports